/* ============================================================================
   F-72 (2026-05-25): Mobile menu Talk CTA → popup toggle
   Click Talk button → opens popup with team info + LINE CTA
   Close on X click / backdrop click / Escape key
   ============================================================================ */
(function () {
  'use strict';

  function init() {
    var toggles = document.querySelectorAll('[data-sh-talk-toggle]');
    var popup = document.querySelector('[data-sh-talk-popup]');
    if (!toggles.length || !popup) return;

    var closeEls = popup.querySelectorAll('[data-sh-talk-close]');
    var card = popup.querySelector('.sh-mb-talk-popup__card');

    function setOpen(open) {
      popup.setAttribute('aria-hidden', open ? 'false' : 'true');
      popup.classList.toggle('is-open', open);
      toggles.forEach(function (t) {
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (open && card) {
        // Move focus into the card for accessibility
        setTimeout(function () {
          var firstFocus = card.querySelector('.sh-mb-talk-popup__close');
          if (firstFocus) firstFocus.focus();
        }, 50);
      }
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = popup.classList.contains('is-open');
        setOpen(!isOpen);
      });
    });

    closeEls.forEach(function (close) {
      close.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setOpen(false);
      });
    });

    // Click outside card (but inside popup overlay) closes it — handled by backdrop element
    // Escape key closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        setOpen(false);
      }
    });

    // Prevent clicks inside card from bubbling to backdrop
    if (card) {
      card.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
